import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';

import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private httpHeader = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
  })

  public timeconfig: any
  counter: any
  constructor(
    private router: Router,
    private http: HttpClient,
  ) { }

  getPostAPI(path: string, requestObj: any, env?: false, headers?: null) {
    {
      if (headers) {
        this.httpHeader = new HttpHeaders(headers)
      }
      let url = this.serviceUrl(path)
      return this.http.post<any>(url, requestObj)
    }
  }

  getCallAPI(path: string, headers?: null): Observable<any> {
    if (headers) {
      this.httpHeader = new HttpHeaders(headers)
    }
    let url = this.serviceUrl(path)
    return this.http.get<any>(url, { headers: this.httpHeader })
  }

  postLoginAPI(path: string, requestObj: any, env?: false, headers?: null) {
    if (headers) {
      this.httpHeader = new HttpHeaders(headers)
    }
    let url = this.loginUrl(path)
    return this.http.post<any>(url, requestObj, { headers: this.httpHeader }).pipe(
      map((response: any) => {
        if (response && response.token) {
          sessionStorage.setItem('token', response.token);
        }
        return response;
      })
    );

  }

  getLoginAPI(path: string, headers?: null): Observable<any> {
    if (headers) {
      this.httpHeader = new HttpHeaders(headers)
    }
    let url = this.loginUrl(path)
    return this.http.get<any>(url, { headers: this.httpHeader })
  }

  isLoggedIn() {
    if (typeof window === 'undefined') {
      return true;
    }
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    return !!token && token !== 'null' && token !== 'undefined' && token !== '';
  }

  logoutAndRedirect() {
    sessionStorage.clear();
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }

  serviceUrl(path: any) {
    return `${environment.apiBaseUrl}/${path}`;
    // return environment.production ? path : `${environment.apiBaseUrl}/${path}`;
  }

  loginUrl(path: string) {
    return `${environment.loginAPIUrl}/${path}`;
  }
}
